export const translation_hi = {
  "welcome": "Welcome to our website",
  "description": "This is an i18n example.",
  "alertMessage":"गलत जवाब, कृपया फिर से चयन करें।",
  "taskdetaitls":{
    "educational":{
      "type":"शैक्षिक",
      "note_label":"नोट:",
      "note":"नोट: क्विज़ पूरा करने के लिए वीडियो को ध्यान से देखे ",
      "note1":"वीडियो को ध्यान से देखें और कार्य पूरा करने के लिए उसी अनुसार नेविगेट करें",
      "start_btn":"क्विज़ शुरू करें",
      "question_lable":"प्रश्न",
      "quest_submit_btn":"सबमिट करें",
      "attempts":"प्रयास बाकी",
      "next_btn":"अगला सवाल",
      "result_btn":"सबमिट करें ",
      "try_again_btn":"दोबारा प्रयास करे",
      "result":{
        
          "message_positive":"बधाई हो! आपके पॉइंट्स हैं",
          "message_feedback":"बधाई हो! टास्क पूरा हो गया है",
          "sub_message_feedback":"आपके फ़ीडबैक के लिए धन्यवाद",
          "message_negative":"आप के पॉइंट्स कम हैं! कृपया कोई भी टास्क शुरू करें",
          "question_answered":"कुल सही जवाब",
          "point_balance":"कुल पॉइंट्स प्राप्त",
          "go_to_home":"होमपेज पर वापस जाएं"
        }
    },
    "watch_videos":{
      "type":"वॉचवीडियो",
      "note_label":"नोट:",
      "note":"नोट: क्विज़ पूरा करने के लिए वीडियो को ध्यान से देखे ",
      "note1":"वीडियो को ध्यान से देखें और टास्क पूरा करने के लिए उसी अनुसार नेविगेट करें",
      "start_btn":"क्विज़ शुरू करें",
      "question_lable":"प्रश्न",
      "quest_submit_btn":"पॉइंट हिस्ट्री पर जाएं",
      "attempts":"प्रयास बाकी",
      "next_btn":"अगला सवाल",
      "result_btn":"सबमिट करें ",
      "try_again_btn":"दोबारा प्रयास करे",
      "result":{
        "message":"बधाई हो! टास्क पूरा हो गया है।",
        "sub_message":"यह वर्तमान में रिव्यु में है और {{points}} अंक वीडियो अनुसार नेविगेट करने पर जोड़े जाएंगे।",
        "go_to_home":"पॉइंट हिस्ट्री पर जाएं",
        "check_status":"टास्क का स्टेटस चेक करें"
      }
    },
    "feedback":{
      "type":"फीडबैक",
      "note_label":"नोट:",
      "notlikely":"बिलकुल नहीं",
      "extlikely":"अत्यधिक संभावना",
      "note":"नोट: क्विज़ पूरा करने के लिए वीडियो को ध्यान से देखे ",
      "start_btn":"क्विज़ शुरू करें",
      "question_lable":"प्रश्न",
      "quest_submit_btn":"सबमिट करें",
      "attempts":"प्रयास बाकी",
      "next_btn":"अगला सवाल",
      "result_btn":"सबमिट करें ",
      "try_again_btn":"दोबारा प्रयास करे",
      "result":{
          "message_positive":"बधाई हो! आपके पॉइंट्स हैं",
          "message_negative":"आप के पॉइंट्स कम हैं! कृपया कोई भी टास्क शुरू करें",
          "question_answered":"कुल सही जवाब",
          "point_balance":"कुल पॉइंट्स प्राप्त",
          "go_to_home":"होमपेज पर वापस जाएं"
        }
    },
    "competition":{
      "type":"कॉम्पिटिशन",
      "note_label":"नोट:",
      "note":"नोट: क्विज़ पूरा करने के लिए वीडियो को ध्यान से देखे ",
      "start_btn":"क्विज़ शुरू करें",
      "question_lable":"प्रश्न",
      "quest_submit_btn":"सबमिट करें",
      "attempts":"प्रयास बाकी",
      "next_btn":"अगला सवाल",
      "result_btn":"सबमिट करें ",
      "try_again_btn":"दोबारा प्रयास करे",
      "result":{
          "message_positive":"बधाई हो! आपके पॉइंट्स हैं",
          "message_negative":"आप के पॉइंट्स कम हैं! कृपया कोई भी टास्क शुरू करें",
          "question_answered":"कुल सही जवाब",
          "point_balance":"कुल पॉइंट्स प्राप्त",
          "go_to_home":"होमपेज पर वापस जाएं"
        }
    },
    "dot_code_scanning":{
      "type":"डॉटकोडस्केनिंनग",
      "sample_img_label":"सैंपल फोटो",
      "step_label":"निर्देश",
      "submit":"टास्क शुरू करें",
      "label":"{{completedSteps}}/{{totalSteps}} - पैक स्कैन किए गए",
      "note_label":"नोट:",
      "note":"{{points}} अंक केवल कार्य पूर्ण होने पर ही प्रदान किए जाएंगे",
      "initnote":"दिए गए हर प्रकार के 1 पैक को स्कैन करें और अंक प्राप्त करें",
      "watch_now":"वीडियो देखें",
      "picture":"चित्र",
      "monthly_ins":"अनुदेश",
      "monthly_submit":"अंक अर्जित करने के लिए पैक स्कैन करें",
      "monthly_note":"कृपया 50 पैक तक स्कैन करने के लिए नीचे दिए गए बटन पर क्लिक करें",
      "scan_earn":"स्कैन करें और कमाएं",
      "month_target":"मासिक लक्ष्य",
      "points_earned_month":"अर्जित अंक",
      "list_of_variants":"वेरिएंट की सूची",
      "days_left_month": "बाकी",
    },
    "availability":{
      "type":"उपलब्धता",
      "take_photo_btn":"एक फोटो लें",
      "retake_photo_btn":"रिटेक",
      "submit":"सबमिट",
      "continue":"जारी रखें",
      "quest_submit_btn":"सबमिट करें",
      "step_label":"चरण",
      "sample_img_label":"सैंपल फोटो",
      "clicked_img_label":"क्लिकेड इमेज",
      "picture":"चित्र",
      "uploading":"अपलोडिंग...",
      "result":{
        "message":"बधाई हो! टास्क पूरा हो गया है।",
        "sub_message":"यह वर्तमान में रिव्यु में है और {{points}} अंक जल्द ही जोड़े जाएंगे।",
        "go_to_home":"Go to Home",
        "check_status":"टास्क का स्टेटस चेक करें"
      }
    },
    "image_recogx":{
      "type":"इमेजरिकग्नाइज",
      "take_photo_btn":"एक फोटो लें",
      "retake_photo_btn":"रिटेक",
      "submit":"सबमिट",
      "quest_submit_btn":"सबमिट करें",
      "step_label":"चरण",
      "sample_img_label":"सैंपल फोटो",
      "clicked_img_label":"क्लिकेड इमेज",
      "picture":"चित्र",
      "uploading":"अपलोडिंग...",
      "result":{
        "message":"बधाई हो! टास्क पूरा हो गया है।",
        "sub_message":"यह वर्तमान में रिव्यु में है और {{points}} अंक जल्द ही जोड़े जाएंगे।",
        "go_to_home":"Go to Home",
        "check_status":"टास्क का स्टेटस चेक करें"
      }
    },
    "buildstick":{
      "type":"बिल्डस्टिक",
      "note_label":"नोट:",
      "note":"सही फ्लेवर को हाइलाइट किए गए स्थान में खींचें और छोड़ें",
      "note1":"वीडियो को ध्यान से देखें और कार्य पूरा करने के लिए उसी अनुसार नेविगेट करें",
      "start_btn":"क्विज़ शुरू करें",
      "question_lable":"प्रश्न",
      "quest_submit_btn":"सबमिट करें",
      "attempts":"प्रयास बाकी",
      "next_btn":"अगला सवाल",
      "result_btn":"सबमिट करें ",
      "try_again_btn":"दोबारा प्रयास करे",
      "alertErrorMessage":"Wrong flavour selected",
      "alertSuccessMessage":"Correct flavour selected",
      "result":{
          "message_positive":"बधाई हो! आपके पॉइंट्स हैं",
          "message_negative":"आप के पॉइंट्स कम हैं! कृपया कोई भी टास्क शुरू करें",
          "question_answered":"कुल सही जवाब",
          "point_balance":"कुल पॉइंट्स प्राप्त",
          "go_to_home":"होमपेज पर वापस जाएं"
        }
    },
    "clicklink":{
      "type":"क्लिकलिंक",
      "download1":"Google Play Store",
      "download2":"App Store",
      "quest_submit_btn":"मैं पुष्टि करता हूँ कि मैंने ऐप डाउनलोड किया है",
      "next_btn":"नेक्स्ट",
      "note":"यह App आगे आने वाले टास्क्स के लिए ज़रूरी है।",
      "result":{
          "message_positive":"बधाई हो! आपके पॉइंट्स हैं",
          "message_negative":"आप के पॉइंट्स कम हैं! कृपया कोई भी टास्क शुरू करें",
          "question_answered":"कुल सही जवाब",
          "point_balance":"कुल पॉइंट्स प्राप्त",
          "go_to_home":"होमपेज पर वापस जाएं"
        }
    },
    "hold_on_title":"रुकिए!",
    "hold_on_message":"क्या आप क्विज़ छोड़ना चाहते हैं? आपकी सारी कमाई प्रगति खत्म हो जाएगी",
    "hold_on_yes":"हां",
    "hold_on_no":"नहीं"
  },
  "tasks":{
      "active_tab":"ऐक्टिव टास्क",
      "inreview_tab":"रिव्यु में",
      "completed_tab":"सम्पन्न टास्क"
    },
    "earn_pnts": {
       "points_earned": "{{points}} पॉइंट्स जीतें",
        "points_earned_top": "{{points}} जीतें",
       "rupee_credited": "{{amount}} जमा हो गए",
       "points_earn": "{{points}} पॉइंट्स पाएं",
        "points_cridited":" पॉइंट्स जमा हो गए",
        "points_earned_diwali": "टास्क {{points}} + बोनस {{bonus}} पॉइंट्स जीतें",
        "points_earn_diwali": "टास्क {{points}} + बोनस {{bonus}} पॉइंट्स पाएं",
         "points_earns" :"पॉइंट्स पॉइंट्स",
          "credited_on":"क्रेडिट की तारीख:",
          
          
 
     },
     "status_type":{
      "review":"रिव्यू हो रहा है / इन रिव्यू",
      "status_review":"स्टेटस - रिव्यू किया जा रहा है"
     },
      "profile":{
      "profile_heading":"आप एक स्टार रिटेलर हैं, आप अपने शहर के मुख्य 20 रिटेलर में शामिल हैं!"
     },
     "days_left": {
      "one": " दिन बाकी",
      "other": " दिन बाकी"
    },
     "task_names":{
      "start_the_task":"कार्य शुरू करें",
      "loading":"loading...",
      "restart_the_task":"कार्य फिर से शुरू करें",
      "start_the_quiz":"प्रश्नोत्तरी शुरू करें",
      "expired":"समाप्त",
      "resume_task":"फिर से प्रारंभ करें",
      "in_review":"रिव्यू में",
     },
     "rewards":{
      "title":"रिवॉर्ड और वाउचर",
      "sub_title":"अपने टास्क पूरे करें और आकर्षक वाउचर और गिफ्ट पाएं!",
      "view_all_reward":"रिवॉर्ड्स अँड व्हाउचर्स देखिये"
     },
       "task":"कार्य",
      "diwali_points":{
       "congratulations_title":"बधाई हो! दीपावली धमाका कार्य पूरा हो गया है।",
       "in_review":"स्टेटस - रिव्यू किया जा रहा है",
      "task_pts":"रिव्यू में:",
       "bonus_pts":"कार्य अंक :",
       "bonus_pts_text":"टास्क {{task_points}} + बोनस {{bonus_pts}} पॉइंट्स रिव्यू पूर्ण होने पर क्रेडिट किया जाएगा।",

      "points_earned": "अर्जित अंक"
     },
     "day_left": "दिन बाकी",
     "days_lefts": "दिन बाकी",
     "hour_left": "घंटा",
     "hours_left": "घंटे",
     "expired": "समाप्त",
     "totol_points_earned":"कुल अर्जित",
     "total_redeemed":"टोटल रिडीम्ड",
     "pts":"अंक",
     "transactions":"लेन-देन",
     "months":"महीने",
     "results_from_last":"पिछले से परिणाम",
     "filter_by_month":"महीने के अनुसार फ़िल्टर करें",
     "select_year":"वर्ष चयन करें",
     "select_month":"महीना चयन करें",
     "apply_text":"लागू करें",
     "okay_text":"ठीक है!",
     "transactions_popup":{
      "note":"नोट",
      "earned_points_valid_till":"अर्जित अंक वैध हैं तक",
      "answered_correctly":"सही उत्तर दिया",
      "questions":"प्रश्न",
      "points_earned":"अर्जित अंक"
     },
     "varients":"प्रकार",
     "status":"स्टेटस",
     "uh_no_resubmit":"ओह नहीं! कार्य फिर से करना होगा।",
     "picture":"तस्वीर",
     "rejected":"रद्द",
     "or":"या",
     "reason":"कारण"
}